export const workShiftClockActionEnum = ['clock-in', 'clock-out'] as const
export type WorkShiftClockAction = (typeof workShiftClockActionEnum)[number]

export const workShiftClockActionLabels = {
  'clock-in': 'Arrivée',
  'clock-out': 'Départ',
} as const
